<template>
  <div class="ATradeTable">
    <div>
      <div class="flex">
        <div v-if="!hideTaxRate" class="mt-tiny" style="width: 120px;">
          <el-input
            v-model="tax_rate"
            v-mask="'##'"
            :disabled="disabled"
            @change="handleChangeTaxRate"
          >
            <template slot="prepend">세액</template>
          </el-input>
        </div>
        <div class="sum-row ml-default flex-auto">
          <el-col :span="4" class="sum-title">합계금액</el-col>
          <el-col :span="10" class="sum-column">{{
            sum_price | numberToKorean
          }}</el-col>
          <el-col :span="10" class="sum-column"
            >￦ {{ util.numberWComma(sum_price) }}</el-col
          >
        </div>
      </div>
    </div>
    <div class="row-splitter">
      <table>
        <tr>
          <th width="60"></th>
          <th width="20">No</th>
          <th width="100" v-if="showDate">일자</th>
          <th width="40">코드</th>
          <th width="190">품명</th>
          <th width="110">규격</th>
          <th width="40">수량</th>
          <th width="60">단위</th>
          <th width="70">단가</th>
          <th v-if="showPyungProcessingCost" width="70">평단가</th>
          <th v-if="showPyungProcessingCost" width="70">가공비</th>
          <th width="70" v-if="!hideSupplyPrice">공급가</th>
          <th width="60" v-if="!hideTaxAmount">세액</th>
          <th width="70">금액</th>
          <th>비고</th>
          <th v-if="showField" width="100">현장</th>
          <th v-if="showSpecification" width="70">사양</th>
          <th v-if="showAddition" width="70">개별</th>
          <th v-if="showGoods" width="60">품번</th>
        </tr>
        <tr v-for="(item, index) in totalItems" v-bind:key="index">
          <td>
            <div v-if="!item.option_id">
              <el-button
                type="primary"
                class="button__add_row"
                :disabled="disabled"
                @click="handleClickAddRow(index)"
                >+</el-button
              >
              <el-button
                type="danger"
                class="button__delete_row"
                :disabled="disabled"
                @click="handleClickDeleteRow(index, item)"
                >-</el-button
              >
              <el-button
                type="text"
                class="button__copy_row el-icon-copy-document"
                :disabled="disabled || !item.product_name"
                @click="handleClickCopyRow(index, item)"
              ></el-button>
            </div>
          </td>
          <td>{{ item.option_id ? "*" : item.seq }}</td>
          <td v-if="showDate">
            <el-input size="tiny" v-model="item.date" />
          </td>
          <td>{{ item.code }}</td>
          <td class="flex">
            <AProductSelector
              size="tiny"
              class="p-field product"
              :value="item.product_name"
              :showSaleOnly="showSaleOnly"
              :disabled="disabled || !!item.option_id"
              @select="handleSelectProduct(item, $event)"
              @clear="handleClearProduct(index)"
            />
            <div v-if="isGlass(item)" class="glass-option">
              <el-popover
                :ref="'glassOption' + index"
                placement="top"
                title="유리옵션"
                width="600"
                trigger="click"
                :disabled="disabled"
                @show="handleShowGlassOption(index)"
              >
                <span slot="reference">유리옵션</span>
                <el-form
                  :ref="'form' + index"
                  label-width="70px"
                  class="form-label-70"
                  :model="item"
                  :rules="showPyungProcessingCost ? {} : rules"
                >
                  <el-row>
                    <el-col :span="10">
                      <el-form-item label="색상" prop="glass_color_id">
                        <AGlassColorSelector
                          v-model="item.glass_color_id"
                          :product_id="item.product_id"
                          @change="calculateGlass(item)"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="두께" prop="glass_thickness_id">
                        <AGlassThicknessSelector
                          v-model="item.glass_thickness_id"
                          :product_id="item.product_id"
                          :glass_color_id="item.glass_color_id"
                          @change="calculateGlass(item)"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="면취" prop="glass_chamfer_type">
                        <AGlassChamferSelector
                          v-model="item.options.glass_chamfer_type"
                          @change="calculateGlass(item)"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="따내기" prop="glass_chip_count">
                        <ANumberSelector
                          v-model="item.options.glass_chip_count"
                          suffix-string="개"
                          :max-number="10"
                          show-zero
                          @change="calculateGlass(item)"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="타공비" prop="glass_punching_price">
                        <ANumberInput
                          v-model="item.options.glass_punching_price"
                          @change="calculateGlass(item)"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        label="R가공비"
                        prop="glass_processing_price"
                      >
                        <ANumberInput
                          v-model="item.options.glass_processing_price"
                          @change="calculateGlass(item)"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="마크무" prop="glass_mark">
                        <el-checkbox
                          v-model="item.options.glass_mark"
                          @change="(e) => calculateGlass(item)"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
                <div class="mt-default">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleClickGlassOption"
                    >확인</el-button
                  >
                </div>
              </el-popover>
            </div>
            <div v-if="isGoods(item)" class="goods-option">
              <el-popover
                :ref="'goodsOption' + index"
                v-if="isGoods(item)"
                placement="top"
                title="기계옵션"
                width="750"
                trigger="click"
                :disabled="disabled"
                @show="handleShowGoodsOption(index)"
              >
                <span slot="reference">기계옵션</span>
                <el-radio-group v-model="active_tab">
                  <el-radio-button label="사양" />
                  <el-radio-button label="비고" />
                </el-radio-group>
                <div v-if="active_tab === '사양'" class="goods-options">
                  <el-checkbox
                    v-for="option in current_options.specifications"
                    v-model="option.checked"
                    :key="option.id"
                    :label="option.name"
                    @change="handleChangeGoodsSpecifications($event, option.id)"
                  />
                </div>
                <div v-else class="goods-options">
                  <el-checkbox
                    v-for="option in current_options.descriptions"
                    v-model="option.checked"
                    :key="option.id"
                    :label="option.name"
                    @change="handleChangeGoodsDescriptions($event, option.id)"
                  />
                </div>
                <div class="mt-default">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleClickGoodsOption"
                    >확인</el-button
                  >
                </div>
              </el-popover>
            </div>
            <div v-if="isDoor(item)" class="door-option">
              <el-popover
                :ref="'doorOption' + index"
                v-if="isDoor(item)"
                placement="top"
                title="도어옵션"
                width="600"
                trigger="click"
                :disabled="disabled"
                @show="handleShowDoorOption(index)"
              >
                <span slot="reference">도어옵션</span>
                <el-radio-group v-model="door_active_tab">
                  <el-radio-button label="옵션" />
                  <el-radio-button label="사양" />
                  <el-radio-button label="비고" />
                </el-radio-group>
                <div v-if="door_active_tab === '옵션'" class="door-options">
                  <el-form
                    :ref="'door-form' + index"
                    label-width="70px"
                    class="form-label-70"
                    :model="item"
                    :rules="rules"
                  >
                    <el-row>
                      <el-col :span="10">
                        <el-form-item label="색상" prop="door_color_id">
                          <ADoorColorSelector
                            v-model="item.door_color_id"
                            :product_id="item.product_id"
                            @change="calculateDoor(item)"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="14">
                        <div class="ml-default inline" style="width: 110px;">
                          <ACheckboxYN
                            v-model="item.options.door_knob_flag"
                            @change="calculateDoor(item)"
                            >손잡이 타공</ACheckboxYN
                          >
                        </div>
                        <div class="ml-default inline" style="width: 200px;">
                          <el-input
                            v-model="item.options.door_knob"
                            :disabled="item.options.door_knob_flag !== 'Y'"
                            @change="calculateDoor(item)"
                          />
                        </div>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="4">
                        <el-form-item label="조립" prop="door_assemble_flag">
                          <ACheckboxYN
                            v-model="item.options.door_assemble_flag"
                            @change="calculateDoor(item)"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item
                          label="조립일정"
                          prop="door_assemble_date"
                        >
                          <ADatePicker
                            v-model="item.options.door_assemble_date"
                            :disabled="item.options.door_assemble_flag !== 'Y'"
                            @change="calculateDoor(item)"
                          />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
                <div v-if="door_active_tab === '사양'" class="door-options">
                  <el-checkbox
                    v-for="option in current_options.specifications"
                    v-model="option.checked"
                    :key="option.id"
                    :label="option.name"
                    @change="handleChangeGoodsSpecifications($event, option.id)"
                  />
                </div>
                <div v-if="door_active_tab === '비고'" class="door-options">
                  <el-checkbox
                    v-for="option in current_options.descriptions"
                    v-model="option.checked"
                    :key="option.id"
                    :label="option.name"
                    @change="handleChangeGoodsDescriptions($event, option.id)"
                  />
                </div>
                <div class="mt-default">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="handleClickDoorOption"
                    >확인</el-button
                  >
                </div>
              </el-popover>
            </div>
          </td>
          <td>
            <div class="flex" style="width: 120px;">
              <div class="flex-auto">
                <el-input
                  size="tiny"
                  v-model="item.size"
                  :disabled="disabled"
                  @change="handleChangeSize(item, false)"
                />
              </div>
              <div
                v-if="isGlass(item)"
                style="min-width: 40px; width: 40px; padding-left: 5px"
                class="flex-fixed"
              >
                <ANumberInput
                  v-model="item.glass_pyung"
                  v-readonly
                  placeholder="평"
                  :disabled="disabled"
                  allowDecimal
                />
              </div>
            </div>
          </td>
          <td>
            <ANumberInput
              v-model="item.amount"
              :disabled="disabled"
              allowDecimal
              @change="handleChangeAmount(item)"
            />
          </td>
          <td>
            <AProductUnitSelector
              v-model="item.unit_id"
              :id="item.product_id"
              :disableSizeAmount="disableSizeAmount"
              :disabled="disabled"
            />
          </td>
          <td>
            <ANumberInput
              v-model="item.cost"
              :disabled="disabled || (isGlass(item) && showPyungProcessingCost)"
              :allowDecimal="!showSaleOnly"
              @change="calculateSupplyPrice(item)"
            />
          </td>
          <td v-if="showPyungProcessingCost">
            <ANumberInput
              v-model="item.pyung_cost"
              :disabled="disabled || !isGlass(item) || !showPyungProcessingCost"
              :allowDecimal="!showSaleOnly"
              @change="calculateSupplyPrice(item)"
            />
          </td>
          <td v-if="showPyungProcessingCost">
            <ANumberInput
              v-model="item.item_processing_cost"
              :disabled="disabled || !isGlass(item) || !showPyungProcessingCost"
              :allowDecimal="!showSaleOnly"
              @change="calculateSupplyPrice(item)"
            />
          </td>
          <td v-if="!hideSupplyPrice">
            <ANumberInput v-model="item.supply_price" v-readonly />
          </td>
          <td v-if="!hideTaxAmount">
            <ANumberInput
              v-model="item.tax"
              :disabled="disabled"
              @change="calculatePrice(item)"
            />
          </td>
          <td>
            <ANumberInput v-model="item.price" v-readonly />
          </td>
          <td>
            <el-input
              v-model="item.desc"
              size="tiny"
              maxlength="100"
              :disabled="disabled"
            />
          </td>
          <td v-if="showField">
            <el-input
              v-model="item.field"
              size="tiny"
              maxlength="100"
              :disabled="disabled"
            />
          </td>
          <td v-if="showSpecification">
            <div v-if="!item.option_id">
              <el-select
                class="tag-last_only_show"
                v-model="item.specification"
                size="mini"
                :disabled="disabled || !!item.product_kind"
                multiple
                collapse-tags
                @change="handleChangeSpecification(item, $event)"
              >
                <el-option
                  v-for="item in specificationOptions(item.seq)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div v-else>
              {{ item.specification[0] }}
              <el-button
                size="mini"
                type="danger"
                icon="el-icon-delete"
                class="ml-default"
                circle
                @click="handleClickRemoveGoodsSpecification(index)"
              />
            </div>
          </td>
          <td v-if="showAddition">
            <el-popover
              v-if="!disabled && !item.option_id"
              :ref="'contractAddition' + index"
              :options="{ offsets: 10 }"
              placement="top"
              width="250"
            >
              <el-form label-width="70px" class="form-label-70">
                <el-form-item label="우편번호" prop="zipcode">
                  <el-input
                    v-model="item.zipcode"
                    class="zipcode readonly"
                    readonly
                  />
                  &nbsp;
                  <el-button
                    @click="popupZipcode(handleCompleteZipcode, item, index)"
                    >우편번호검색</el-button
                  >
                </el-form-item>
                <el-form-item label="도착지" prop="destination">
                  <el-input v-model="item.destination" />
                </el-form-item>
                <el-form-item label="담당자" prop="charger">
                  <el-input v-model="item.charger" style="width:130px" />
                </el-form-item>
                <el-form-item label="납기일" prop="delivery_date">
                  <ADatePicker v-model="item.delivery_date" />
                </el-form-item>
                <el-form-item label="출하방법" prop="delivery_way_flag">
                  <ADeliveryWaySelector v-model="item.delivery_way_flag" />
                </el-form-item>
                <el-form-item label="개별일정" prop="schedule_flag">
                  <!-- <el-checkbox v-model="item.schedule_flag"/> -->
                  <ACheckboxYN v-model="item.schedule_flag" />
                </el-form-item>
              </el-form>
              <div>
                <el-button
                  type="primary"
                  @click="handleClickContractAdditionOK(index)"
                  >확인</el-button
                >
                <el-button @click="handleClickContractAdditionInit(item, index)"
                  >초기화</el-button
                >
              </div>
              <el-button
                slot="reference"
                :type="resolveIsDifferentAddition(item) ? 'danger' : ''"
              >
                {{ resolveIsDifferentAddition(item) ? "개별" : "------" }}
              </el-button>
            </el-popover>
          </td>
          <td v-if="showGoods">
            <el-popover
              placement="bottom"
              width="350"
              trigger="hover"
              :options="{ offsets: 10 }"
              v-if="item.goods && item.goods.length > 0"
            >
              <el-table :data="item.goods" max-height="400">
                <el-table-column
                  prop="code"
                  label="품번"
                  width="170"
                ></el-table-column>
                <el-table-column
                  prop="product_name"
                  label="제품"
                  show-overflow-tooltip
                ></el-table-column>
              </el-table>
              <el-button
                v-if="!disableModify"
                class="mt-default"
                @click="handleClickModifyGoods(item)"
                >변경</el-button
              >
              <span slot="reference">
                {{ util.getGoodsSerialCode(item) }}
              </span>
            </el-popover>
          </td>
        </tr>
        <tr v-if="!hideSumRow">
          <td :colspan="summaryLeftColumnCount">합 계</td>
          <td><ANumberInput v-model="sum_amount" v-readonly /></td>
          <td :colspan="showPyungProcessingCost ? 3 : 2"></td>
          <td v-if="showPyungProcessingCost">
            <ANumberInput v-model="sum_processing_price" v-readonly />
          </td>
          <td v-if="!hideSupplyPrice">
            <ANumberInput v-model="sum_supply_price" v-readonly />
          </td>
          <td v-if="!hideTaxAmount">
            <ANumberInput v-model="sum_tax" v-readonly />
          </td>
          <td>
            <ANumberInput v-model="sum_price" v-readonly />
          </td>
          <td>&nbsp;</td>
        </tr>
      </table>

      <el-dialog
        custom-class="form-dialog"
        top="100px"
        width="400px"
        title="품번관리"
        :modal="false"
        :visible.sync="dialog_visible"
        :close-on-click-modal="false"
        destroyOnClose
      >
        <GoodsForm
          v-if="dialog_visible"
          :data="goods"
          @completed="handleCompletedGoodsForm"
          @updated="handleUpdatedGoodsForm"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Trade } from "@/common/function/class";
import { zipcode_search } from "@/common/mixins/zipcode_search";
import { company_info } from "@/common/mixins/company_info";
import readonly from "@/common/directive/readonly";
import AGlassChamferSelector from "@/shared/AGlassChamferSelector";
import AGlassThicknessSelector from "@/shared/AGlassThicknessSelector";
import AGlassColorSelector from "@/shared/AGlassColorSelector";
import ADoorColorSelector from "@/shared/ADoorColorSelector";
import GoodsForm from "@/spa/Common/GoodsForm";

export default {
  name: "ATradeTable",
  mixins: [zipcode_search, company_info],
  components: {
    AGlassChamferSelector,
    AGlassThicknessSelector,
    AGlassColorSelector,
    GoodsForm,
    ADoorColorSelector,
  },
  directives: { readonly },
  data() {
    return {
      company: {
        show_pyung_processing_cost: false,
      },
      rules: {
        glass_color_id: [
          {
            required: true,
            message: "선택하세요.",
            trigger: ["blur", "change"],
          },
        ],
        glass_thickness_id: [
          {
            required: true,
            message: "선택하세요.",
            trigger: ["blur", "change"],
          },
        ],
      },
      totalItems: [],
      sum_amount: 0,
      sum_supply_price: 0,
      sum_processing_price: 0,
      sum_tax: 0,
      sum_price: 0,
      tax_rate: 10,
      maxCount: 20,
      popup_option_index: -1,
      current_options: {
        specifications: [],
        descriptions: [],
      },
      current_door_options: {
        specifications: [],
        descriptions: [],
      },
      dialog_visible: false,
      currentItem: undefined,
      goods: [],
      active_tab: "사양",
      door_active_tab: "옵션",
      next_seq: 1,
      currentIndex: -1,
      changeCustomer: null,
    };
  },
  props: {
    rowCount: { type: Number, default: 20 },
    showDate: { type: Boolean, default: false },
    showColor: { type: Boolean, default: false },
    hideSupplyPrice: { type: Boolean, default: false },
    hideTaxAmount: { type: Boolean, default: false },
    hideSumRow: { type: Boolean, default: false },
    showSpecification: { type: Boolean, default: false },
    showGoods: { type: Boolean, default: false },
    showField: { type: Boolean, default: false },
    items: { type: Array, default: () => new Array() },
    customer: { type: Object, default: () => null },
    showSaleOnly: { type: Boolean, default: false },
    /**
     * 규격수량 비활성화 여부
     */
    disableSizeAmount: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    /**
     * 편집 가능 여부(기계번호)
     */
    disableModify: { type: Boolean, default: false },
    hideTaxRate: { type: Boolean, default: false },
    showAddition: { type: Boolean, default: false },
    delivery_date: { type: String },
    delivery_way_flag: { type: String },
    destination: { type: String },
    charger: { type: String },
  },
  watch: {
    table_config() {
      this.loadConfig();
    },
    sum_price(val) {
      this.$emit("changedSum", val);
    },
    customer(newVal, oldVal) {
      if (!(newVal && newVal.id) || !(oldVal && oldVal.id)) {
        return;
      }
      this.totalItems.forEach((item) => {
        this.getPrice(item);
      });
    },
    items: {
      deep: true,
      handler() {
        // 외부에서 items가 변경되었을 때는 초기화한다.
        // 현 컴포넌트 내의 변경에서는 호출되지 않아야 한다.
        this.initItems();
      },
    },
    delivery_date: function(newVal, oldVal) {
      if (!newVal) {
        return;
      }
      this.totalItems.forEach((item) => {
        if (item.delivery_date === oldVal) {
          item.delivery_date = newVal;
        }
      });
    },
    delivery_way_flag: function(newVal, oldVal) {
      if (!newVal) {
        return;
      }
      this.totalItems.forEach((item) => {
        if (item.delivery_way_flag === oldVal) {
          item.delivery_way_flag = newVal;
        }
      });
    },
  },
  created() {
    for (let i = 0; i < this.rowCount; i++) {
      this.totalItems.push(new Trade());
    }
    this.EventBus.$on("changeCostByCustomer", this.eventChangeCostByCustomer);
  },
  mounted() {
    this.initItems();
    this.loadConfig();
  },
  beforeDestroy() {
    this.EventBus.$off("changeCostByCustomer", this.eventChangeCostByCustomer);
  },
  computed: {
    ...mapGetters([
      "table_product_price",
      "table_product",
      "table_product_glass_price",
      "table_glass_color",
      "table_glass_thickness",
      "table_option",
      "table_product_door_price",
      "table_door_color",
      "table_product_door_color_price",
    ]),
    showPyungProcessingCost() {
      return this.showSaleOnly && this.company.show_pyung_processing_cost;
    },
    summaryLeftColumnCount() {
      return this.showDate ? 6 : 5;
    },
  },
  methods: {
    eventChangeCostByCustomer(param) {
      if (param) {
        this.changeCustomer = param;
        this.totalItems.forEach((item) => {
          this.getPrice(item);
        });
      }
    },
    getCustomer() {
      if (this.changeCustomer) return this.changeCustomer;
      else return this.customer;
    },
    initItems() {
      this.sum_amount = 0;
      this.sum_supply_price = 0;
      this.sum_processing_price = 0;
      this.sum_tax = 0;
      this.sum_price = 0;
      this.tax_rate = 10;
      let items = [];
      this.next_seq = 1;
      this.items.forEach((item) => {
        if (item.product_id) {
          let p = this.table_product.find((p) => p.id === item.product_id);
          if (p) {
            item.code = p.code;
          }
        }
        if (item.options) {
          if (item.product_kind === "GLASS") {
            item.glass_pyung = item.options.glass_pyung;
            item.glass_color_id = item.options.glass_color_id;
            item.glass_thickness_id = item.options.glass_thickness_id;
          } else if (item.product_kind === "DOOR") {
            item.door_color_id = item.options.door_color_id;
          }
        }
        items.push(this.util.clone(item));
      });
      for (let i = 0; i < items.length; i++) {
        /**
         * ERP-591 발주 등록 가져올 때 중복 seq 발생
         * sequence 번호가 순차적으로 표시되지 않고, 불러온 수주/발주 항목에 표시된 sequence 번호되로 표시되는 문제
         * 그리고, 'option_id' 정보가 있으면 sequence 번호를 증가하지 않음
         * 이유는 'option_id' 정보가 있는 경우는,
         * 수주 등록시 품목을 선택 후 부가적으로 유리/기계/도어 옵션 항목이 선택되어 등록된 경우
         * 옵션 정보들은 sequence 번호가 아닌 '*' 로 표시
         */
        if (items[i].option_id) {
          // 옵션이라면 전행의 seq를 맞춘다.
          items[i].seq = this.next_seq - 1;
          if (items[i].specification && items[i].specification.length == 1) {
            items[i].specification = [this.next_seq - 1];
          }
          continue;
        }
        items[i].seq = this.next_seq++;
        // if (items[i].seq > this.next_seq) {
        //   let target_seq = items[i].seq;
        //   for(let j=this.next_seq; j<target_seq; j++) {
        //     let item = new Trade();
        //     item.seq = j;
        //     items.splice(i, 0, item);
        //   }
        //   this.next_seq = target_seq + 1;
        // } else {
        //   this.next_seq = items[i].seq + 1;
        // }
      }
      for (let i = items.length; i < this.rowCount; i++) {
        let item = new Trade();
        item.seq = this.next_seq++;
        items.push(item);
      }
      this.totalItems = items;
      if (this.totalItems.length > 0) {
        this.calculateSum();
      } else {
        this.sum_amount = 0;
        this.sum_supply_price = 0;
        this.sum_processing_price = 0;
        this.sum_tax = 0;
        this.sum_price = 0;
      }
      this.util.fireResize();
    },
    clearItems() {
      let items = [];
      for (let i = 0; i < this.rowCount; i++) {
        items.push(new Trade());
      }
      this.totalItems = items;
      this.sum_amount = 0;
      this.sum_supply_price = 0;
      this.sum_processing_price = 0;
      this.sum_tax = 0;
      this.sum_price = 0;
    },
    resetGlassItems() {
      this.totalItems.forEach((item) => {
        if (item.product_kind === "GLASS") {
          this.calculateGlass(item);
        } else if (item.product_kind === "DOOR") {
          this.calculateDoor(item);
        }
        this.getPrice(item);
      });
    },
    calculateGlass(item) {
      if (!item.product_id || item.product_kind !== "GLASS") {
        this.calculateSupplyPrice(item);
        return;
      }
      let etcDesc = item.desc ? item.desc : "";

      if (etcDesc) {
        etcDesc = etcDesc.replace(item.options.glass_color_name, "");
        etcDesc = etcDesc.replace(item.options.glass_thickness_name + "T", "");
        for (
          let i = this.system.options.glass_chamfer_type.length - 1;
          i >= 0;
          i--
        ) {
          let glass_chamfer_types = this.system.options.glass_chamfer_type[i];
          if (etcDesc.includes(glass_chamfer_types.label)) {
            etcDesc = etcDesc.replace(
              glass_chamfer_types.value
                ? glass_chamfer_types.label + "면취"
                : "면취무",
              ""
            );
            break;
          }
        }
        etcDesc = etcDesc.replaceAll(/(따내기:\w+개)/g, "");
        etcDesc = etcDesc.replace("마크무", "");
        etcDesc = etcDesc.trim();
      }

      item.options.glass_color_id = item.glass_color_id;
      item.options.glass_thickness_id = item.glass_thickness_id;

      let trade = item;
      if (typeof item === "number") {
        trade = this.totalItems[item];
      }
      let cost = this.util.removeComma(trade.cost);
      if (cost === undefined) {
        cost = null;
      }
      let item_processing_cost = this.util.removeComma(
        trade.item_processing_cost
      );
      if (item_processing_cost === undefined) {
        item_processing_cost = null;
      }
      let glass_price;
      let glass_color, glass_thickness, glass_chamfer;
      let trade_pyung_cost = 0;
      //유리 조건이 맞다면 유리 가격을 구한다.
      if (
        trade.product_kind === "GLASS" &&
        this.isAvailableSize(trade.size) &&
        trade.options.glass_color_id &&
        trade.options.glass_thickness_id
      ) {
        glass_color = this.table_glass_color.find(
          (c) => c.id === trade.options.glass_color_id
        );
        glass_thickness = this.table_glass_thickness.find(
          (t) => t.id === trade.options.glass_thickness_id
        );
        glass_chamfer = this.system.options.glass_chamfer_type.find(
          (t) => t.value === trade.options.glass_chamfer_type
        );
        if (glass_color && glass_thickness) {
          glass_price = this.table_product_glass_price.find((p) => {
            return (
              p.product_id === trade.product_id &&
              p.glass_color_id === glass_color.id &&
              p.glass_thickness_id === glass_thickness.id
            );
          });
        }
        trade.options.glass_color_name = glass_color ? glass_color.name : "";
        trade.options.glass_thickness_name = glass_thickness
          ? glass_thickness.name
          : "";

        //유리 옵션 정보를 비고에 복사
        let desc =
          trade.options.glass_color_name +
          " " +
          trade.options.glass_thickness_name +
          "T";
        if (glass_chamfer.value !== "no_chamfer") {
          desc += " " + glass_chamfer.label;
          if (glass_chamfer.value) desc += "면취";
        }
        if (trade.options.glass_chip_count) {
          desc += " 따내기:" + trade.options.glass_chip_count + "개";
        }
        if (trade.options.glass_mark) {
          desc += " 마크무";
        }

        trade.desc = desc + " " + etcDesc;
      }
      //유리 가격이 있다면 규격 정보를 읽어 단가를 계산한다.
      let arSize = trade.size.split("*");
      if (
        arSize.length == 2 &&
        Number.parseInt(arSize[0]) &&
        Number.parseInt(arSize[1])
      ) {
        let horizontal = Number.parseInt(arSize[0]);
        let vertical = Number.parseInt(arSize[1]);
        // let pyung = trade.glass_pyung ? trade.glass_pyung : horizontal * vertical / 90000;
        let pyung = this.util.calculatePyung(horizontal, vertical, true);
        if (this.showPyungProcessingCost) {
          pyung = pyung < 3 ? 3 : pyung;
        }
        // 면취
        let chamfer_type = trade.options.glass_chamfer_type;
        let chamfer_cost = glass_price?.chamfer_price || 0;
        // 따내기
        let chip_cost = trade.options.glass_chip_count
          ? trade.options.glass_chip_count * glass_price.chip_price
          : 0;
        // 평당 단가
        let pyung_cost =
          this.getProductGlassCost(glass_price) || trade.pyung_cost;
        // 공정, 타공단가
        let processing_cost = trade.options.glass_processing_price
          ? trade.options.glass_processing_price
          : 0;
        let punching_cost = trade.options.glass_punching_price
          ? trade.options.glass_punching_price
          : 0;
        let chamfer_size = 0;
        let ar_chamfer_type = [];
        if (chamfer_type) {
          for (let i = 0; i < chamfer_type.length / 2; i++) {
            ar_chamfer_type.push(chamfer_type.substring(i * 2, i * 2 + 2));
          }
          ar_chamfer_type.forEach((ct) => {
            switch (ct) {
              case "h1":
                chamfer_size += horizontal;
                break;
              case "h2":
                chamfer_size += horizontal * 2;
                break;
              case "v1":
                chamfer_size += vertical;
                break;
              case "v2":
                chamfer_size += vertical * 2;
                break;
            }
          });
        }
        chamfer_size = chamfer_size / 300;
        if (pyung_cost) {
          trade_pyung_cost = pyung_cost;
          if (!this.showPyungProcessingCost) {
            cost =
              Math.ceil(pyung_cost * pyung) +
              Math.ceil(chamfer_cost * chamfer_size) +
              chip_cost +
              punching_cost +
              processing_cost;
          } else {
            cost = Math.ceil(pyung_cost * pyung);
            item_processing_cost =
              Math.ceil(chamfer_cost * chamfer_size) +
                chip_cost +
                punching_cost +
                processing_cost || trade.item_processing_cost;
          }
        }
        //소수점 2자리 이하를 올림한다.
        trade.glass_pyung = pyung.toFixed(2);
        trade.options.glass_pyung = Number.parseFloat(trade.glass_pyung);
        trade.pyung_cost = pyung_cost;
        trade.item_processing_cost = item_processing_cost;
      }
      if (this.showSaleOnly) {
        trade.cost = cost;
        trade.pyung_cost = trade_pyung_cost;
        trade.item_processing_cost = item_processing_cost;
      }
      this.calculateSupplyPrice(trade);
    },
    calculateDoor(item, changeDesc = true) {
      if (!item.product_id || item.product_kind !== "DOOR") {
        this.calculateSupplyPrice(item);
        return;
      }
      let etcDesc = item.desc ? item.desc : "";
      let origin_color_name = this.table_door_color.find(
        (c) => c.id === item.options.door_color_id
      )?.name;

      if (item.desc) {
        if (origin_color_name) etcDesc = etcDesc.replace(origin_color_name, "");
        if (etcDesc.includes("손잡이타공("))
          etcDesc = etcDesc.replace(/(손잡이타공\([^]+\))/, "");
        else etcDesc = etcDesc.replace("손잡이타공", "");
        etcDesc = etcDesc.replace("조립", "");
        if (item.options.descriptions && item.options.descriptions.length > 0) {
          item.options.descriptions.forEach((d) => {
            etcDesc = etcDesc.replace(d.name, "");
          });
        }
        etcDesc = etcDesc.trim();
      }

      item.options.door_color_id = item.door_color_id;
      let cost = this.util.removeComma(item.cost);
      if (cost === undefined) {
        cost = null;
      }
      let door_price, door_color_price;
      let door_color;
      if (item.options.door_color_id) {
        door_price = this.table_product_door_price.filter((p) => {
          return p.product_id === item.product_id;
        });
        door_color = this.table_door_color.find(
          (c) => c.id === item.options.door_color_id
        );
        if (door_color) {
          door_color_price = this.table_product_door_color_price.find((p) => {
            return (
              p.product_id === item.product_id &&
              p.door_color_id === item.options.door_color_id
            );
          });
        }
        item.options.door_color_name = door_color ? door_color.name : "";

        //유리 옵션 정보를 비고에 복사
        if (changeDesc) {
          let desc = item.options.door_color_name;
          if (item.options.door_knob_flag === "Y") {
            desc += " 손잡이타공";
            if (item.options.door_knob) {
              desc += "(" + item.options.door_knob + ")";
            }
          }
          if (item.options.door_assemble_flag === "Y") {
            desc += " 조립";
          }
          if (
            item.options.descriptions &&
            item.options.descriptions.length > 0
          ) {
            item.options.descriptions.forEach((d) => {
              desc += " " + d.name;
            });
          }
          item.desc = desc + " " + etcDesc;
        }
      }
      item.assemble_date =
        item.options.door_assemble_flag === "Y"
          ? item.options.door_assemble_date
          : null;
      if (this.isAvailableSize(item.size) && door_price) {
        let arSize = item.size.split("*");
        if (
          arSize.length == 2 &&
          Number.parseInt(arSize[0]) &&
          Number.parseInt(arSize[1])
        ) {
          let h = Number.parseInt(arSize[0]);
          let v = Number.parseInt(arSize[1]);
          let h_price = door_price.find(
            (p) =>
              p.size_type_flag === "1" && p.size_begin <= h && p.size_end >= h
          );
          let v_price = door_price.find(
            (p) =>
              p.size_type_flag === "2" && p.size_begin <= v && p.size_end >= v
          );
          let h_real_price = this.getProductDoorCost(h_price);
          let v_real_price = this.getProductDoorCost(v_price);
          cost = 0;
          if (h_real_price) cost += h_real_price;
          if (v_real_price) cost += v_real_price;
          if (item.options.door_assemble_flag === "Y") {
            if (h_price && h_price.assemble_price) {
              cost += h_price.assemble_price;
            }
            if (v_price && v_price.assemble_price) {
              cost += v_price.assemble_price;
            }
          }
          if (door_color_price) {
            cost += door_color_price.price;
          }
        }
      }
      if (this.showSaleOnly) {
        item.cost = cost;
      }
      this.calculateSupplyPrice(item);
    },
    calculateSupplyPrice(item) {
      if (item.amount) {
        if (this.showPyungProcessingCost && this.isGlass(item)) {
          let arSize = item.size.split("*");
          let horizontal = Number.parseInt(arSize[0]);
          let vertical = Number.parseInt(arSize[1]);
          // let pyung = trade.glass_pyung ? trade.glass_pyung : horizontal * vertical / 90000;
          let pyung = this.util.calculatePyung(horizontal, vertical, true);
          pyung = pyung < 3 ? 3 : pyung;
          let pyung_cost = 0;
          pyung_cost = Math.ceil(item.pyung_cost * pyung);

          item.cost = pyung_cost;
          item.supply_price =
            Math.round(item.cost * item.amount) +
            Math.round(item.item_processing_cost * item.amount);
        } else {
          item.supply_price = Math.round(item.cost * item.amount);
        }
        item.tax = Math.ceil(item.supply_price * (this.tax_rate / 100));
        this.calculatePrice(item);
      } else {
        item.supply_price = null;
        item.tax = null;
        item.price = null;
        this.calculateSum();
      }
    },
    calculatePrice(item) {
      item.price = item.supply_price + item.tax;
      this.calculateSum();
    },
    /** 전체 합계 계산 */
    calculateSum() {
      let sum_amount = 0;
      let sum_supply_price = 0;
      let sum_processing_price = 0;
      let sum_tax = 0;
      let sum_price = 0;
      this.totalItems.forEach((item) => {
        if (!item.product_id && !item.option_id) {
          return true;
        }
        sum_amount += item.amount;
        if (item.price) {
          sum_supply_price += Number.parseInt(item.supply_price);
          sum_processing_price += Number.parseInt(
            item.item_processing_cost || 0
          );
          sum_tax += Number.parseInt(item.tax);
          sum_price += Number.parseInt(item.price);
        }
      });
      this.sum_amount = sum_amount;
      if (this.sum_price === sum_price) {
        return;
      }
      this.sum_supply_price = sum_supply_price;
      this.sum_processing_price = sum_processing_price;
      this.sum_tax = sum_tax;
      this.sum_price = sum_price;
      // this.$emit('changedSum', this.sum_price);
    },
    result() {
      return this.totalItems;
    },
    /** 단가 구하기 */
    getPrice(trade) {
      if (!this.getCustomer() || !this.getCustomer().id) {
        return;
      }
      if (!trade.product_id) {
        return;
      }
      if (!this.showSaleOnly) {
        this.calculateGlass(trade);
        return;
      }
      let cost = this.getProductCost(trade.product_id);
      if (cost) trade.cost = cost;
      if (trade.product_kind === "GLASS" || trade.product_kind === "DOOR") {
        return;
      }
      if (!cost) trade.cost = null;
      this.api
        .listContractHistory(this.getCustomer().id, trade.product_id)
        .then((res) => {
          if (res.length < 1) {
            return;
          }
          trade.contract_history = res.data;
          //이력이 있다면 마지막 이력의 단가를 적용한다.
          if (
            trade.contract_history.length > 0 &&
            trade.cost !== trade.contract_history[0].cost
          ) {
            trade.cost = trade.contract_history[0].cost;
          }
          this.calculateSupplyPrice(trade);
        });
      if (!trade.cost) {
        this.calculateSupplyPrice(trade);
        return;
      }
      this.calculateSupplyPrice(trade);
    },
    /**
     * 제품에 대한 단가를 계산
     */
    getProductCost(product_id) {
      if (!product_id) {
        return;
      }
      let price = this.table_product_price.find((p) => {
        return p.product_id === product_id;
      });
      if (!price) {
        return;
      }
      let cost = price.price;
      if (this.getCustomer()) {
        let customer_price = price.customers.find(
          (c) => c.customer_level_id === this.getCustomer().customer_level_id
        );
        if (customer_price) {
          if (customer_price.ratio_flag === "Y") {
            cost = (cost / 100) * customer_price.price;
          } else {
            cost = customer_price.price;
          }
        }
      }
      return cost;
    },
    getProductGlassCost(product_glass_price) {
      if (!product_glass_price) {
        return;
      }
      let cost = product_glass_price.price;
      if (this.getCustomer()) {
        let customer_price = product_glass_price.customers.find(
          (c) =>
            c.customer_glass_level_id ===
            this.getCustomer().customer_glass_level_id
        );
        if (customer_price) {
          if (customer_price.ratio_flag === "Y") {
            cost = (cost / 100) * customer_price.price;
          } else {
            cost = customer_price.price;
          }
        }
      }
      return cost;
    },
    getProductDoorCost(product_door_price) {
      if (!product_door_price) {
        return;
      }
      let cost = product_door_price.price;
      if (this.getCustomer()) {
        let customer_price = product_door_price.customers.find(
          (c) =>
            c.customer_door_level_id ===
            this.getCustomer().customer_door_level_id
        );
        if (customer_price) {
          if (customer_price.ratio_flag === "Y") {
            cost = (cost / 100) * customer_price.price;
          } else {
            cost = customer_price.price;
          }
        }
      }
      return cost;
    },
    isAvailableSize(size) {
      return (
        size &&
        size.length > 2 &&
        size.indexOf("*") > 0 &&
        size.indexOf("*") < size.length
      );
    },
    clear() {
      this.clearItems();
    },
    specificationOptions(current_seq) {
      let ret = [];
      ret.push({ value: null, label: " " });
      for (let i = 1; i < current_seq; i++) {
        ret.push({ value: i, label: i.toString() });
      }
      return ret;
    },
    isGlass(item) {
      // 품목의 유리 여부
      return item.product_kind === "GLASS";
    },
    isGoods(item) {
      return this.showSaleOnly && item.product_kind === "GOODS";
    },
    isDoor(item) {
      return this.showSaleOnly && item.product_kind === "DOOR";
    },
    addNewItem() {
      let item = new Trade();
      item.seq = this.totalItems[this.totalItems.length - 1].seq + 1;
      this.totalItems.push(item);
    },
    sortGoodsByName(data) {
      let tmpMap = new Map();
      data.map((o) => {
        let name = o.price
          ? o.name + " (" + this.util.addComma(o.price) + ")"
          : o.name;
        tmpMap.set(name, o);
      });
      var sortMap = new Map([...tmpMap.entries()].sort());
      return Array.from(sortMap.values());
    },
    getGoodsSpecifications(item) {
      let options = this.table_option.filter(
        (o) =>
          o.product_kind === "GOODS" &&
          o.class_flag === "1" &&
          o.use_flag === "Y"
      );
      options = this.sortGoodsByName(options);
      return options.map((o) => {
        return {
          id: o.id,
          checked:
            item.options.specifications.findIndex((s) => s.id === o.id) > -1,
          name: o.price
            ? o.name + " (" + this.util.addComma(o.price) + ")"
            : o.name,
        };
      });
    },
    getGoodsDescriptions(item) {
      let options = this.table_option.filter(
        (o) =>
          o.product_kind === "GOODS" &&
          o.class_flag === "2" &&
          o.use_flag === "Y"
      );
      options = this.sortGoodsByName(options);
      return options.map((o) => {
        return {
          id: o.id,
          checked:
            item.options.descriptions.findIndex((d) => d.id === o.id) > -1,
          name: o.name,
        };
      });
    },
    getDoorSpecifications(item) {
      let options = this.table_option.filter(
        (o) =>
          o.product_kind === "DOOR" &&
          o.class_flag === "1" &&
          o.use_flag === "Y"
      );
      options = this.sortGoodsByName(options);
      return options.map((o) => {
        return {
          id: o.id,
          checked:
            item.options.specifications.findIndex((s) => s.id === o.id) > -1,
          name: o.price
            ? o.name + " (" + this.util.addComma(o.price) + ")"
            : o.name,
        };
      });
    },
    getDoorDescriptions(item) {
      let options = this.table_option.filter(
        (o) =>
          o.product_kind === "DOOR" &&
          o.class_flag === "2" &&
          o.use_flag === "Y"
      );
      options = this.sortGoodsByName(options);
      return options.map((o) => {
        return {
          id: o.id,
          checked:
            item.options.descriptions.findIndex((d) => d.id === o.id) > -1,
          name: o.name,
        };
      });
    },
    /**
     * 사양 옵션을 선택하면 추가한다.
     */
    async addGoodsSpecification(id) {
      let option = this.table_option.find((o) => o.id === id);
      if (!option) {
        return;
      }

      let option_cost = null;
      let param = {
        customer_id: this.getCustomer().id,
        option_id: option.id,
      };
      await this.api.getOptionCost(param).then((res) => {
        if (res.data.length > 0) {
          option_cost = res.data[0].option_cost;
        }
      });

      let seq = this.totalItems[this.popup_option_index].seq;
      let index = this.totalItems.findIndex((item) => item.seq === seq + 1);
      let item = new Trade();
      item.seq = seq;
      item.option_id = option.id;
      if (option.addition.length > 0) {
        // 옵션 추가 품목의 id를 product_id로 넣는다. (큰 의미 없음)
        item.product_id = option.addition[0].product_id;
      }
      item.product_name = option.name;
      item.amount = 1;
      if (!option_cost) {
        item.cost = option.price;
      } else {
        item.cost = option_cost;
      }
      const desc = option.desc?.slice(0, 1) === "!";
      item.specification = [seq];
      item.product_kind = "OPTION";
      item.desc = !desc ? option.desc : "";
      if (index > -1) {
        this.totalItems.splice(index, 0, item);
        let last = this.totalItems[this.totalItems.length - 1];
        if (!last.product_id && !last.option_id) {
          this.totalItems.pop();
          this.next_seq--;
        }
      } else {
        this.totalItems.push(item);
      }
      this.calculateSupplyPrice(item);
    },
    /**
     * 사양 옵션을 선택 해제하면 삭제한다.
     */
    removeGoodsSpecification(id) {
      let seq = this.totalItems[this.popup_option_index].seq;
      let index = this.totalItems.findIndex((item) => {
        return (
          item.specification &&
          item.specification.includes(seq) &&
          item.option_id === id
        );
      });
      if (index < 1) {
        return;
      }
      this.totalItems.splice(index, 1);
      this.addNewItem();
    },
    /**
     * 비고 옵션을 선택하면 비고에 추가한다.
     */
    addGoodsDescription(id) {
      let option = this.table_option.find((o) => o.id === id);
      if (!option) {
        return;
      }
      let item = this.totalItems[this.popup_option_index];
      if (!item.desc) {
        item.desc = "";
      } else {
        item.desc += " ";
      }
      item.desc += option.name;
    },
    removeGoodsDescription(id) {
      let option = this.table_option.find((o) => o.id === id);
      if (!option) {
        return;
      }
      let item = this.totalItems[this.popup_option_index];
      item.desc = item.desc.replace(option.name, "").replace("  ", " ");
    },
    resolveIsDifferentAddition(item) {
      if (
        (item.destination && item.destination !== this.destination) ||
        (item.charger && item.charger !== this.charger) ||
        (item.delivery_date && item.delivery_date !== this.delivery_date) ||
        (item.delivery_way_flag &&
          item.delivery_way_flag !== this.delivery_way_flag)
      ) {
        return true;
      }
      return false;
    },
    handleSelectProduct(item, p) {
      if (typeof p === "object") {
        item.code = p.code;
        item.product_name = p.name;
        item.product_id = p.id;
        item.size = p.size;
        if (!item.amount) {
          item.amount = 1;
        }
        item.product_kind = p.kind;
        if (item.product_kind === "GOODS") {
          item.options = {
            specifications: [],
            descriptions: [],
          };
        } else if (item.product_kind === "GLASS") {
          item.options = {
            glass_pyung: 0,
            glass_color_id: null,
            glass_color_name: "",
            glass_thickness_id: null,
            glass_thickness_name: "",
            glass_chamfer_type: "no_chamfer",
            glass_chip_count: 0,
            glass_punching_price: 0,
            glass_processing_price: 0,
            glass_mark: false,
          };
        } else if (item.product_kind === "DOOR") {
          item.options = {
            specifications: [],
            descriptions: [],
            door_color_id: null,
            door_knob_flag: "N",
            door_knob: null,
            door_assemble_flag: "N",
            door_assemble_date: null,
          };
        }
      } else {
        item.product_kind = null;
        item.options = null;
        if (p === "") {
          item.code = null;
          item.size = null;
          item.amount = null;
          item.cost = null;
          item.supply_price = null;
          item.tax = null;
          item.price = null;
          item.desc = null;
        }
        item.product_name = p;
        item.product_id = null;
      }
      this.getPrice(item);
    },
    handleChangeSpecification(item, values) {
      // null 값을 선택하면 선택 값을 해제한다.
      let reset = values.findIndex((v) => v === null);
      if (reset < 0) {
        return;
      }
      item.specification = null;
    },
    handleShowGlassOption(index) {
      this.popup_option_index = index;
      if (!this.totalItems[index].options) {
        this.totalItems[index].options = {
          glass_color_id: null,
          glass_thickness_id: null,
          glass_chamfer_type: null,
        };
      }
    },
    handleShowGoodsOption(index) {
      this.popup_option_index = index;
      if (!this.totalItems[index].options) {
        this.totalItems[index].options = {
          specifications: [],
          descriptions: [],
        };
      }
      this.current_options = {
        specifications: this.getGoodsSpecifications(this.totalItems[index]),
        descriptions: this.getGoodsDescriptions(this.totalItems[index]),
      };
    },
    handleShowDoorOption(index) {
      this.popup_option_index = index;
      if (!this.totalItems[index].options) {
        this.totalItems[index].options = {
          door_assemble: "Y",
        };
      }
      this.current_options = {
        specifications: this.getDoorSpecifications(this.totalItems[index]),
        descriptions: this.getDoorDescriptions(this.totalItems[index]),
      };
    },
    handleClickGlassOption() {
      this.$refs["form" + this.popup_option_index][0].validate((valid) => {
        if (!valid) {
          return;
        }
        this.$refs["glassOption" + this.popup_option_index][0].doClose();
      });
    },
    handleClickGoodsOption() {
      this.$refs["goodsOption" + this.popup_option_index][0].doClose();
    },
    handleClickDoorOption() {
      this.$refs["doorOption" + this.popup_option_index][0].doClose();
    },
    handleChangeSize(item, changeDesc = true) {
      if (item.product_kind === "GLASS") {
        if (this.isAvailableSize(item.size)) {
          let arSize = item.size.split("*");
          if (
            arSize.length == 2 &&
            Number.parseInt(arSize[0]) &&
            Number.parseInt(arSize[1])
          ) {
            let horizontal = arSize[0];
            let vertical = arSize[1];
            let pyung = this.util.calculatePyung(horizontal, vertical, true);
            if (this.showPyungProcessingCost) {
              pyung = pyung < 3 ? 3 : pyung;
            }
            item.glass_pyung = pyung;
            item.options.glass_pyung = Number.parseFloat(pyung);
          }
        }
        this.calculateGlass(item);
      } else if (item.product_kind === "DOOR") {
        this.calculateDoor(item, changeDesc);
      }
    },
    handleChangeAmount(item) {
      if (item.product_kind === "GLASS") {
        this.calculateGlass(item);
      } else if (item.product_kind === "DOOR") {
        this.calculateDoor(item);
      } else {
        this.calculateSupplyPrice(item);
      }
    },
    handleChangeTaxRate() {
      this.totalItems.forEach((item) => {
        if (item.supply_price) {
          item.tax = (item.supply_price * this.tax_rate) / 100;
          item.price = item.supply_price + item.tax;
        }
      });
      this.calculateSum();
    },
    handleClickModifyGoods(item) {
      this.currentItem = item;
      let goods = Object.assign([], item.goods);
      goods.forEach((g) => {
        g.original_code = g.code;
      });
      this.goods = goods;
      this.dialog_visible = true;
    },
    handleUpdatedGoodsForm(goods) {
      goods.forEach((good) => {
        let index = this.currentItem.goods.findIndex((g) => g.id === good.id);
        if (index > -1) {
          this.currentItem.goods.splice(index, 1, good);
        }
      });
      this.$emit("updated");
    },
    handleCompletedGoodsForm() {
      this.dialog_visible = false;
    },
    handleChangeGoodsSpecifications(checked, id) {
      let options = this.totalItems[this.popup_option_index].options
        .specifications;
      if (checked) {
        let option = this.table_option.find((o) => o.id === id);
        options.push({
          id: id,
          name: option.name,
        });
        this.addGoodsSpecification(id);
      } else {
        let index = options.findIndex((e) => e.id === id);
        if (index > -1) {
          options.splice(index, 1);
          this.removeGoodsSpecification(id);
        }
      }
    },
    handleChangeGoodsDescriptions(checked, id) {
      let options = this.totalItems[this.popup_option_index].options
        .descriptions;
      if (checked) {
        let option = this.table_option.find((o) => o.id === id);
        options.push({
          id: option.id,
          name: option.name,
        });
        this.addGoodsDescription(id);
      } else {
        let index = options.findIndex((o) => o.id === id);
        if (index > -1) {
          options.splice(index, 1);
          this.removeGoodsDescription(id);
        }
      }
    },
    handleClickRemoveGoodsSpecification(index) {
      let item = this.totalItems[index];
      let goods = this.totalItems.find((i) => i.seq === item.specification[0]);
      goods.options.specifications.splice(
        goods.options.specifications.findIndex((s) => s === item.option_id),
        1
      );
      this.totalItems.splice(index, 1);
      this.addNewItem();
      this.calculateSum();
    },
    handleChangeDoorDescription(checked, item) {
      item.desc = checked === "Y" ? "" : "알유리만";
    },
    handleClearProduct(index) {
      let item = this.totalItems[index];
      item.door_color_id = null;
      for (var i = this.totalItems.length - 1; i >= 0; i--) {
        if (
          this.totalItems[i].specification != null &&
          item.seq === this.totalItems[i].specification[0]
        ) {
          this.totalItems.splice(i, 1);
          this.addNewItem();
        }
      }

      this.calculateSum();
    },
    handleCompleteZipcode(zipcode, addr, item /*, index*/) {
      item.zipcode = zipcode;
      item.destination = addr + " ";
    },
    handleClickContractAdditionOK(index) {
      this.$refs["contractAddition" + index][0].doClose();
    },
    handleClickContractAdditionInit(item, index) {
      item.zipcode = null;
      item.destination = null;
      item.charger = null;
      item.delivery_date = null;
      item.delivery_way_flag = null;
      item.schedule_flag = null;
      this.handleClickContractAdditionOK(index);
    },
    handleClickAddRow(index) {
      let current_seq = this.totalItems[index].seq;
      this.totalItems
        .filter((item) => item.seq > current_seq)
        .forEach((item) => {
          item.seq++;
          if (item.specification) {
            item.specification = this.resetSpecification(
              item.specification,
              current_seq
            );
          }
        });
      let new_index = this.totalItems.findIndex(
        (item) => item.seq > current_seq
      );
      if (new_index < 1) {
        new_index = index + 1;
      }
      let item = new Trade();
      item.seq = current_seq + 1;
      this.totalItems.splice(new_index, 0, item);
    },
    handleClickDeleteRow(index, item) {
      if (this.totalItems.length < 2) {
        return;
      }
      this.currentIndex = index;
      if (item.product_id) {
        this.util.confirm(
          this,
          "",
          "품목이 이미 선택된 행입니다. 삭제하시겠습니까?",
          this.deleteRow
        );
        return;
      }
      this.deleteRow();
    },
    handleClickCopyRow(index, origin_item) {
      const copy_item = this.util.deepClone(origin_item);
      copy_item.id = null;
      let current_seq = this.totalItems[index].seq;
      this.totalItems
        .filter((item) => item.seq > current_seq)
        .forEach((item) => {
          item.seq++;
          if (item.specification) {
            item.specification = this.resetSpecification(
              item.specification,
              current_seq
            );
          }
        });
      let new_index = this.totalItems.findIndex(
        (item) => item.seq > current_seq
      );
      if (new_index < 1) {
        new_index = this.totalItems.length + 1;
      }
      copy_item.seq = current_seq + 1;
      this.totalItems.splice(new_index, 0, copy_item);
      let specifications = this.util.deepClone(
        this.totalItems.filter((item) => item.seq === current_seq).slice(1)
      );
      let i = 1;
      specifications.map((s) => {
        s.id = null;
        s.seq = copy_item.seq;
        s.specification = [copy_item.seq];
        this.calculateSupplyPrice(s);
        this.totalItems.splice(new_index + i++, 0, s);
      });
      this.calculateSum();
    },
    deleteRow() {
      let current_seq = this.totalItems[this.currentIndex].seq;
      for (let i = this.currentIndex; i < this.totalItems.length; i++) {
        let item = this.totalItems[i];
        if (item.seq === current_seq) {
          this.totalItems.splice(i, 1);
          i--;
        } else {
          item.seq--;
          if (item.specification) {
            item.specification = this.resetSpecification(
              item.specification,
              current_seq,
              false
            );
          }
        }
      }
      this.calculateSum();
    },
    resetSpecification(specification, current_seq, is_plus = true) {
      let ar = [];
      specification.forEach((s) => {
        if (s > current_seq) {
          is_plus ? ar.push(s + 1) : ar.push(s - 1);
        } else {
          ar.push(s);
        }
      });
      return ar;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.ATradeTable {
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    tr {
      height: 28px;
      &:not(:last-child) {
        border-bottom: $border;
      }
      td {
        text-align: center;
        .el-input {
          width: 100%;
        }
        .button__add_row,
        .button__delete_row,
        .button__copy_row {
          padding: 2px;
          width: 16px;
        }
        .button__delete_row,
        .button__copy_row {
          margin-left: 4px;
        }
      }
    }
  }
}
.p-field {
  display: inline-block;
}
.product {
  flex: 5 5 auto;
}
.product + .active {
  width: 80px;
}
.product-option {
  padding-top: 1px;
  flex: 0 0 fixed;
}
.glass-field {
  width: 140px;
}
.glass-option,
.goods-option,
.door-option {
  width: 50px;
  span {
    line-height: 30px;
    font-size: 10px;
    color: #00f;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
